import React, { useEffect, useContext, useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import moment from 'moment'
import Fab from '@material-ui/core/Fab';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Hidden from '@material-ui/core/Hidden';
import Chip from '@material-ui/core/Chip';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';

import { getLeaderboardByChallengeId } from '../../../actions/challenge-actions';

import ChallengeContext from '../../../context/challenge-context'
import { BreadcrumbsCustom } from '../../shared/component'
import useStyles from '../../../styles/components/learningcontent/stylesLearningContents'


const Leaderboard = () => {

    const classes = useStyles();
    const { challengeContext, dispatch } = useContext(ChallengeContext);
    const [isLoading, setIsLoading] = useState(true);
    const [topTenList, setTopTenList] = useState([]);

    useEffect(() => {
        initLeaderboard();
    }, []);

    const initLeaderboard = async () => {
        let response = await getLeaderboardByChallengeId(challengeContext.challenge.ChallengeId);
        setIsLoading(false);
        if (response > 200 || response.status === "Failed") {
            setTopTenList([])
        }
        if (response.status === "Success") {
            setTopTenList(response.data)
        }
    };

    const breadcrumbsData = [
        {
            text: 'Challenge',
            href: '/Challenge'
        },
        {
            text: 'Leaderboard',
            href: ''
        },
    ];

    function secondsToHms(d) {
        d = Number(d);
        let h = Math.floor(d / 3600);
        let m = Math.floor(d % 3600 / 60);
        let s = Math.floor(d % 3600 % 60);

        let hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
        let mDisplay = m > 0 ? m + (m == 1 ? " min, " : " mins, ") : "";
        let sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : " 0 sec";
        let time = hDisplay + mDisplay + sDisplay;
        time = time.length > 0 ? time : "NA"
        return time;
    }

    const handleClickTabs = (item) => {
        switch (item) {
            case "overview":
                challengeContext.tabs.overview = true;
                challengeContext.tabs.teamMember = false;
                challengeContext.tabs.activities = false;
                challengeContext.tabs.leaderboard = false;
                dispatch({ type: 'SET_TABS', tabs: challengeContext.tabs });
                break;
        }
    }

    return (
        <>
            <BreadcrumbsCustom breadcrumbsData={breadcrumbsData} />
            <Grid classes={{ root: classes.rootGridDescription }}>
                <Typography classes={{ root: classes.rootContent }}>Leaderboard</Typography>
            </Grid>
            {
                isLoading ?
                    <Alert style={{ margin: "10px" }} variant="outlined" severity="info">
                        Please wait for a while...
                    </Alert>
                    :
                    <>
                        {
                            topTenList.length > 0 ?
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow style={{ backgroundColor: '#0C8FAD' }}>
                                                <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Rank</TableCell>
                                                <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Team Name</TableCell>
                                                <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Team Size</TableCell>
                                                <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Team Leader</TableCell>
                                                <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Average Score</TableCell>
                                                <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Average TimeTaken</TableCell>
                                                <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Last Attempted Time</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {topTenList.map((row, index) => (
                                                <TableRow key={index}
                                                    style={challengeContext.challenge.TeamName === row.TeamName ? { backgroundColor: 'rgba(98, 197, 218, 0.5)' }
                                                        : { backgroundColor: 'transparent' }}>
                                                    <TableCell align="center">
                                                        {
                                                            index === 0 ?
                                                                <Chip style={{ backgroundColor: '#cd950c', color: 'white' }}
                                                                    icon={<StarIcon style={{ color: 'white' }} />}
                                                                    label={`#${index + 1}`}
                                                                />
                                                                :
                                                                index === 1 || index === 2 ?
                                                                    <Chip style={{ backgroundColor: '#FFA500', color: 'white' }}
                                                                        icon={<StarBorderIcon style={{ color: 'white' }} />}
                                                                        label={`#${index + 1}`}
                                                                    />
                                                                    :
                                                                    <Chip
                                                                        icon={<StarBorderIcon />}
                                                                        label={`#${index + 1}`}
                                                                    />
                                                        }
                                                    </TableCell>
                                                    <TableCell align="center" style={{ overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '15px' }}>{row.TeamName}</TableCell>
                                                    <TableCell align="center">{row.TeamSize}</TableCell>
                                                    <TableCell align="center">{row.TeamLeader}</TableCell>
                                                    <TableCell align="center">{row.AvgScore}</TableCell>
                                                    <TableCell align="center">{secondsToHms(row.AvgTimeTaken)}</TableCell>
                                                    <TableCell align="center">{moment(row.LastAttemptedDateTime).fromNow()}</TableCell>

                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                :
                                <Alert style={{ margin: "10px" }} variant="outlined" severity="info">
                                    No Data
                                </Alert>
                        }
                    </>
            }
            <Hidden lgUp>
                <Fab onClick={() => handleClickTabs("overview")} color="secondary" style={{ position: "fixed", bottom: '5px', right: '5px', margin: '5px' }}>
                    <ArrowBackIcon />
                </Fab>
            </Hidden>
        </>
    );
};

export default Leaderboard;